<div class="list-wrapper">
  <kgrid
    *ngIf="filterInfo && filterInfo.length > 0"
    [apiName]="apiName"
    [label]="label"
    [name]="apiName"
    [areaName]="areaName"
    pathPreFix="HRM"
    [isAdd]="false"
    reportName="HrmBankAccountList"
    [defaultFilterKey]="filterInfo"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
